import { useEffect, useRef } from "react";

/**
 * Hook to enable automatic sliding for KeenSlider.
 * @param {object} slider - The slider instance returned by useKeenSlider.
 */
export function useAutoPlay(slider, delay = 5000) {
    const timeout = useRef();

    useEffect(() => {
        if (!slider.current) return;

        const clearNextTimeout = () => clearTimeout(timeout.current);

        const nextTimeout = () => {
            clearTimeout(timeout.current);
            timeout.current = setTimeout(() => {
                if (slider.current) {
                    slider.current.next();
                }
            }, delay);
        };

        nextTimeout();

        slider.current.on("created", nextTimeout);
        slider.current.on("dragStarted", clearNextTimeout);
        slider.current.on("animationEnded", nextTimeout);
        slider.current.on("updated", nextTimeout);

        return () => clearTimeout(timeout.current);
    }, [slider, delay]);

    return null;
}
